module.exports = __webpack_public_path__ + "img/145.10.9dc632cc.png";